import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  Alert,
  Link,
} from '@mui/material';
import { useUser } from '../contexts/UserContext';

const Register: React.FC = () => {
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [company, setCompany] = useState<string>('');
  // const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [complete, setComplete] = useState<boolean>(false);
  const navigate = useNavigate();
  const { register } = useUser();

  const handleRegister = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');

    // if (password !== confirmPassword) {
    //   setError('Passwords do not match');
    //   return;
    // }

    try {
      await register(firstName, lastName, email, company);
      setComplete(true);
      // navigate('/login');
    } catch (err) {
      console.error('Registration error:', err);
      setError(err instanceof Error ? err.message : 'An unexpected error occurred during registration');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        component="form"
        onSubmit={handleRegister}
        sx={{
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 3,
        }}
      >
        <Box>
          <Box sx={{ height: 125 }}>
            <img src="/logo.svg" alt="Logo" style={{ height: '100%' }} />
          </Box>
          <Box sx={{ height: 30, textAlign: 'center', margin: '0px', mb: 3, }}>
            <img src="/theRoofingApp.svg" alt="The Roofing App" style={{ height: '100%' }} />
          </Box>
        </Box>
        
        <Typography component="h1" variant="h5" gutterBottom>
          Create Account
        </Typography>
        {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
        {complete && <Alert severity="info" sx={{ width: '100%', mb: 2 }}>
          Your registration has been submitted successfully. An email has been set for you to sent your password. Go check your email.
        </Alert>}
        <TextField
          margin="normal"
          required
          fullWidth
          id="firstName"
          label="First Name"
          name="firstName"
          autoComplete="firstName"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />

        <TextField
          margin="normal"
          required
          fullWidth
          id="lastName"
          label="Last Name"
          name="lastName"
          autoComplete="lastName"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />

        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          id="company"
          label="Company Name"
          name="company"
          autoComplete="company"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
        />
        {/* <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        /> */}
        {/* <TextField
          margin="normal"
          required
          fullWidth
          name="confirmPassword"
          label="Confirm Password"
          type="password"
          id="confirmPassword"
          autoComplete="new-password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        /> */}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Register
        </Button>
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Link href="/login" variant="body2">
            Already have an account? Log in
          </Link>
        </Box>
      </Box>
    </Container>
  );
};

export default Register;
